import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import useWindowDimensions from '../hooks/useWindowDimensions';
import './Header.css';

export interface Props {
  isActive: boolean
  setActive: (value:boolean) => void
}

function Header(props:Props) {
  const { height, width } = useWindowDimensions();
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", () =>
      {setScroll(window.pageYOffset > 100)
      }
      );
    }
  }, [window.pageYOffset]);

  if (width < 1024) {
    return (
        <div className={props.isActive? "mobileMenu menuActive": "mobileMenu"}>
          <div className='logoHeader'>
            <img src={require('../assets/InTimeLink_green.svg').default}></img>
            {/* {!props.isActive?
            <span className='openMobile' onClick={() => props.setActive(true)}>MENU</span>
            :
            <img className='mobileIcon' onClick={() => props.setActive(false)} src={require('../assets/close_icon.svg').default}></img>
            } */}
          </div>
          <ul onClick={() => props.setActive(false)}>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/crypto">Crypto</Link></li>
            <li><Link to="/retail">Retail</Link></li>
            <li><Link to="/vending">Vending</Link></li>
            <li><Link to="/BI">Business Intelligence</Link></li>
            <li><Link className='primary green' to="/contacts">Contact us</Link></li>
          </ul>
        </div>
      // <div>
      //   {!props.isActive ?
      //   <div className='mobileMenu'>
      //     <img src={require('../assets/InTimeLink_green.svg').default}></img>
      //     <span className='openMobile' onClick={() => props.setActive(true)}>MENU</span>
      //   </div>
      //   :
      //   <div className='mobileMenuActive'>
      //     <div className='mobileMenu'>
      //       <img src={require('../assets/InTimeLink_green.svg').default}></img>
      //       <img className='mobileIcon' onClick={() => props.setActive(false)} src={require('../assets/close_icon.svg').default}></img>
      //     </div>
      //     <ul>
      //       <li><Link to="/">Home</Link></li>
      //       <li><Link to="/crypto">Crypto</Link></li>
      //       <li><Link to="/retail">Retail</Link></li>
      //       <li><Link to="/vending">Vending</Link></li>
      //       <li><Link to="/BI">Business Intelligence</Link></li>
      //       <li><Link className='primary green' to="/contacts">Contact us</Link></li>
      //     </ul>
      //   </div>
      //   }
      // </div>
    );
  }
  else {
    return (
      <div className={scroll? "Header scroll":"Header"}>
          <img src={require('../assets/InTimeLink_green.svg').default}></img>
          {/* <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/crypto">Crypto</Link></li>
            <li><Link to="/retail">Retail</Link></li>
            <li><Link to="/vending">Vending</Link></li>
            <li><Link to="/BI">Business Intelligence</Link></li>
            <li><Link className='primary green' to="/contacts">Contact us</Link></li>
          </ul> */}
      </div>
    );
  }
}

export default Header;
